module.exports = __webpack_public_path__ + "static/media/filtering-active.29a6a662.svg";